import { render, staticRenderFns } from "./simple-layout.vue?vue&type=template&id=8128ea26"
import script from "./simple-layout.vue?vue&type=script&lang=js"
export * from "./simple-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8128ea26')) {
      api.createRecord('8128ea26', component.options)
    } else {
      api.reload('8128ea26', component.options)
    }
    module.hot.accept("./simple-layout.vue?vue&type=template&id=8128ea26", function () {
      api.rerender('8128ea26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/main/layouts/simple-layout.vue"
export default component.exports